export const getPrefixFromBoardName = (
    boardName: string
) => {
    const nameWords = boardName.replace(/\s+/g, ' ').split(' ');
    if (nameWords.length === 1) {
        return boardName.substring(0, 3).toUpperCase()
    }
    return nameWords.map(word => word[0]).join('').substring(0, 3).toUpperCase()
}
